export const config = {
  app: "catexpert",
  appTitle: "CatExpert.ai - AI Enabled Self-Service Retail Optimizer",
  appFavicon: "assets/images/favicon.ico",
  supportMailID: "catexpert.team@ab-inbev.com",
};
